import React, { useState } from "react";
import { Button, Form, Accordion, Nav, AccordionToggle } from "react-bootstrap";
// import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
// import AccordionContext from "react-bootstrap/AccordionContext";
import "./dropdownSpecifications.css";

export default function DropdownSpecifications({
  selectedData,
  addLabel,
  removeLabel,
}) {
  const [open, setOpen] = useState(true);
  const [activeId, setActiveId] = useState("0");
  // const [panelIndex, setPanelIndex] = useState();

  const handleChange = (label) => () => {
    if (selectedData.indexOf(label) > -1) removeLabel(label);
    else addLabel(label);
  };

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  // const CustomToggle = ({ children, eventKey, callback }) => {
  //   const currentEventKey = React.useContext(AccordionContext);

  //   const decoratedOnClick = useAccordionToggle(
  //     eventKey,
  //     () => callback && callback(eventKey)
  //   );

  //   const isCurrentEventKey = currentEventKey === eventKey;

  //   console.log(eventKey);

  //   return (
  //     <button
  //       style={{ color: isCurrentEventKey ? "orange" : "black" }}
  //       onClick={decoratedOnClick}
  //     >
  //       {children}
  //     </button>
  //   );
  // };

  return (
    <div className="container">
      <div className="group-button">
        <div className="btn btn-secondary dropdown-toggle">
          <Button onClick={() => setOpen(!open)}>استانداردها</Button>
        </div>
      </div>
      <div className="drop-main">
        <div className={`drop-custom ${open ? "drop-custom-show" : ""}`}>
          <div className="accordion">
            <Accordion>
              <div
                className={
                  activeId === "0" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <AccordionToggle
                    onClick={() => toggleActive("0")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="0"
                    
                  >
                    ACEA 2016                
                  </AccordionToggle>
                </div>

                <Accordion.Collapse eventKey="0">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C5-16"
                        id="C5-16"
                        onChange={handleChange("C5-16")}
                        checked={selectedData.indexOf("C5-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C4-16"
                        id="C4-16"
                        onChange={handleChange("C4-16")}
                        checked={selectedData.indexOf("C4-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C3-16"
                        id="C3-16"
                        onChange={handleChange("C3-16")}
                        checked={selectedData.indexOf("C3-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-16"
                        id="C2-16"
                        onChange={handleChange("C2-16")}
                        checked={selectedData.indexOf("C2-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-16"
                        id="C1-16"
                        onChange={handleChange("C1-16")}
                        checked={selectedData.indexOf("C1-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-16"
                        id="A5/B5-16"
                        onChange={handleChange("A5/B5-16")}
                        checked={selectedData.indexOf("A5/B5-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-16"
                        id="A3/B3-16"
                        onChange={handleChange("A3/B3-16")}
                        checked={selectedData.indexOf("A3/B3-16") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-16"
                        id="A3/B4-16"
                        onChange={handleChange("A3/B4-16")}
                        checked={selectedData.indexOf("A3/B4-16") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "1" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <AccordionToggle
                    onClick={() => toggleActive("1")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="1"
                  >
                    ACEA 2012
                  </AccordionToggle>
                </div>

                <Accordion.Collapse eventKey="1">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C4-12"
                        id="C4-12"
                        onChange={handleChange("C4-12")}
                        checked={selectedData.indexOf("C4-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C3-12"
                        id="C3-12"
                        onChange={handleChange("C3-12")}
                        checked={selectedData.indexOf("C3-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-12"
                        id="C2-12"
                        onChange={handleChange("C2-12")}
                        checked={selectedData.indexOf("C2-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-12"
                        id="C1-12"
                        onChange={handleChange("C1-12")}
                        checked={selectedData.indexOf("C1-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-12"
                        id="A5/B5-12"
                        onChange={handleChange("A5/B5-12")}
                        checked={selectedData.indexOf("A5/B5-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-12"
                        id="A3/B4-12"
                        onChange={handleChange("A3/B4-12")}
                        checked={selectedData.indexOf("A3/B4-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-12"
                        id="A3/B3-12"
                        onChange={handleChange("A3/B3-12")}
                        checked={selectedData.indexOf("A3/B3-12") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1/B1-12"
                        id="A1/B1-12"
                        onChange={handleChange("A1/B1-12")}
                        checked={selectedData.indexOf("A1/B1-12") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "2" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("2")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="2"
                  >
                    ACEA 2010
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="2">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C4-10"
                        id="C4-10"
                        onChange={handleChange("C4-10")}
                        checked={selectedData.indexOf("C4-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C3-10"
                        id="C3-10"
                        onChange={handleChange("C3-10")}
                        checked={selectedData.indexOf("C3-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-10"
                        id="C2-10"
                        onChange={handleChange("C2-10")}
                        checked={selectedData.indexOf("C2-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-10"
                        id="C1-10"
                        onChange={handleChange("C1-10")}
                        checked={selectedData.indexOf("C1-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-10"
                        id="A5/B5-10"
                        onChange={handleChange("A5/B5-10")}
                        checked={selectedData.indexOf("A5/B5-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-10"
                        id="A3/B4-10"
                        onChange={handleChange("A3/B4-10")}
                        checked={selectedData.indexOf("A3/B4-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-10"
                        id="A3/B3-10"
                        onChange={handleChange("A3/B3-10")}
                        checked={selectedData.indexOf("A3/B3-10") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1/B1-10"
                        id="A1/B1-10"
                        onChange={handleChange("A1/B1-10")}
                        checked={selectedData.indexOf("A1/B1-10") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "3" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("3")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="3"
                  >
                    ACEA 2008
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="3">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C4-08"
                        id="C4-08"
                        onChange={handleChange("C4-08")}
                        checked={selectedData.indexOf("C4-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C3-08"
                        id="C3-08"
                        onChange={handleChange("C3-08")}
                        checked={selectedData.indexOf("C3-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-08"
                        id="C2-08"
                        onChange={handleChange("C2-08")}
                        checked={selectedData.indexOf("C2-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-08"
                        id="C1-08"
                        onChange={handleChange("C1-08")}
                        checked={selectedData.indexOf("C1-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-08"
                        id="A5/B5-08"
                        onChange={handleChange("A5/B5-08")}
                        checked={selectedData.indexOf("A5/B5-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-08"
                        id="A3/B4-08"
                        onChange={handleChange("A3/B4-08")}
                        checked={selectedData.indexOf("A3/B4-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-08"
                        id="A3/B3-08"
                        onChange={handleChange("A3/B3-08")}
                        checked={selectedData.indexOf("A3/B3-08") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1/B1-08"
                        id="A1/B1-08"
                        onChange={handleChange("A1/B1-08")}
                        checked={selectedData.indexOf("A1/B1-08") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "4" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("4")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="4"
                  >
                    ACEA 2007
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="4">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C4-07"
                        id="C4-07"
                        onChange={handleChange("C4-07")}
                        checked={selectedData.indexOf("C4-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C3-07"
                        id="C3-07"
                        onChange={handleChange("C3-07")}
                        checked={selectedData.indexOf("C3-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-07"
                        id="C2-07"
                        onChange={handleChange("C2-07")}
                        checked={selectedData.indexOf("C2-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-07"
                        id="C1-07"
                        onChange={handleChange("C1-07")}
                        checked={selectedData.indexOf("C1-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-07"
                        id="A5/B5-07"
                        onChange={handleChange("A5/B5-07")}
                        checked={selectedData.indexOf("A5/B5-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-07"
                        id="A3/B4-07"
                        onChange={handleChange("A3/B4-07")}
                        checked={selectedData.indexOf("A3/B4-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-07"
                        id="A3/B3-07"
                        onChange={handleChange("A3/B3-07")}
                        checked={selectedData.indexOf("A3/B3-07") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1/B1-07"
                        id="A1/B1-07"
                        onChange={handleChange("A1/B1-07")}
                        checked={selectedData.indexOf("A1/B1-07") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "5" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("5")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="5"
                  >
                    ACEA 2004
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="5">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="C3-04"
                        id="C3-04"
                        onChange={handleChange("C3-04")}
                        checked={selectedData.indexOf("C3-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C2-04"
                        id="C2-04"
                        onChange={handleChange("C2-04")}
                        checked={selectedData.indexOf("C2-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C1-04"
                        id="C1-04"
                        onChange={handleChange("C1-04")}
                        checked={selectedData.indexOf("C1-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5/B5-04"
                        id="A5/B5-04"
                        onChange={handleChange("A5/B5-04")}
                        checked={selectedData.indexOf("A5/B5-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B4-04"
                        id="A3/B4-04"
                        onChange={handleChange("A3/B4-04")}
                        checked={selectedData.indexOf("A3/B4-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3/B3-04"
                        id="A3/B3-04"
                        onChange={handleChange("A3/B3-04")}
                        checked={selectedData.indexOf("A3/B3-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1/B1-04"
                        id="A1/B1-04"
                        onChange={handleChange("A1/B1-04")}
                        checked={selectedData.indexOf("A1/B1-04") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "6" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("6")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="6"
                  >
                    ACEA 2002
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="6">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="B5-02"
                        id="B5-02"
                        onChange={handleChange("B5-02")}
                        checked={selectedData.indexOf("B5-02") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B4-02"
                        id="B4-02"
                        onChange={handleChange("B4-02")}
                        checked={selectedData.indexOf("B4-02") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B3-98/Issue-2"
                        id="B3-98/Issue-2"
                        onChange={handleChange("B3-98/Issue-2")}
                        checked={selectedData.indexOf("B3-98/Issue-2") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B2-98/Issue-2"
                        id="B2-98/Issue-2"
                        onChange={handleChange("B2-98/Issue-2")}
                        checked={selectedData.indexOf("B2-98/Issue-2") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B1-02"
                        id="B1-02"
                        onChange={handleChange("B1-02")}
                        checked={selectedData.indexOf("B1-02") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A5-02"
                        id="A5-02"
                        onChange={handleChange("A5-02")}
                        checked={selectedData.indexOf("A5-02") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A3-02"
                        id="A3-02"
                        onChange={handleChange("A3-02")}
                        checked={selectedData.indexOf("A3-02") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A2-96/Issue-3"
                        id="A2-96/Issue-3"
                        onChange={handleChange("A2-96/Issue-3")}
                        checked={selectedData.indexOf("A2-96/Issue-3") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A1-02"
                        id="A1-02"
                        onChange={handleChange("A1-02")}
                        checked={selectedData.indexOf("A1-02") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "7" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("7")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="7"
                  >
                    API
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="7">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="SP"
                        id="SP"
                        onChange={handleChange("SP")}
                        checked={selectedData.indexOf("SP") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="SN-PLUS"
                        id="SN-PLUS"
                        onChange={handleChange("SN-PLUS")}
                        checked={selectedData.indexOf("SN-PLUS") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="SN"
                        id="SN"
                        onChange={handleChange("SN")}
                        checked={selectedData.indexOf("SN") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="SM"
                        id="SM"
                        onChange={handleChange("SM")}
                        checked={selectedData.indexOf("SM") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="SL"
                        id="SL"
                        onChange={handleChange("SL")}
                        checked={selectedData.indexOf("SL") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="SJ"
                        id="SJ"
                        onChange={handleChange("SJ")}
                        checked={selectedData.indexOf("SJ") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="CF"
                        id="CF"
                        onChange={handleChange("CF")}
                        checked={selectedData.indexOf("CF") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
              <div
                className={
                  activeId === "8" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("8")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="8"
                  >
                    بنز
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="8">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="MB229.71(2019)"
                        id="MB229.71(2019)"
                        onChange={handleChange("MB229.71(2019)")}
                        checked={selectedData.indexOf("MB229.71(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.61(2019)"
                        id="MB229.61(2019)"
                        onChange={handleChange("MB229.61(2019)")}
                        checked={selectedData.indexOf("MB229.61(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.6(2019)"
                        id="MB229.6(2019)"
                        onChange={handleChange("MB229.6(2019)")}
                        checked={selectedData.indexOf("MB229.6(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.52(2019)"
                        id="MB229.52(2019)"
                        onChange={handleChange("MB229.52(2019)")}
                        checked={selectedData.indexOf("MB229.52(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.51(2019)"
                        id="MB229.51(2019)"
                        onChange={handleChange("MB229.51(2019)")}
                        checked={selectedData.indexOf("MB229.51(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.5(2019)"
                        id="MB229.5(2019)"
                        onChange={handleChange("MB229.5(2019)")}
                        checked={selectedData.indexOf("MB229.5(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.31(2019)"
                        id="MB229.31(2019)"
                        onChange={handleChange("MB229.31(2019)")}
                        checked={selectedData.indexOf("MB229.31(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.3(2019)"
                        id="MB229.3(2019)"
                        onChange={handleChange("MB229.3(2019)")}
                        checked={selectedData.indexOf("MB229.3(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.71(2016)"
                        id="MB229.71(2016)"
                        onChange={handleChange("MB229.71(2016)")}
                        checked={selectedData.indexOf("MB229.71(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.6(2016)"
                        id="MB229.6(2016)"
                        onChange={handleChange("MB229.6(2016)")}
                        checked={selectedData.indexOf("MB229.6(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.52(2016)"
                        id="MB229.52(2016)"
                        onChange={handleChange("MB229.52(2016)")}
                        checked={selectedData.indexOf("MB229.52(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.51(2016)"
                        id="MB229.51(2016)"
                        onChange={handleChange("MB229.51(2016)")}
                        checked={selectedData.indexOf("MB229.51(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.5(2016)"
                        id="MB229.5(2016)"
                        onChange={handleChange("MB229.5(2016)")}
                        checked={selectedData.indexOf("MB229.5(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.31(2016)"
                        id="MB229.31(2016)"
                        onChange={handleChange("MB229.31(2016)")}
                        checked={selectedData.indexOf("MB229.31(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.3(2016)"
                        id="MB229.3(2016)"
                        onChange={handleChange("MB229.3(2016)")}
                        checked={selectedData.indexOf("MB229.3(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.1(2016)"
                        id="MB229.1(2016)"
                        onChange={handleChange("MB229.1(2016)")}
                        checked={selectedData.indexOf("MB229.1(2016)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.52(2012)"
                        id="MB229.52(2012)"
                        onChange={handleChange("MB229.52(2012)")}
                        checked={selectedData.indexOf("MB229.52(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.51(2012)"
                        id="MB229.51(2012)"
                        onChange={handleChange("MB229.51(2012)")}
                        checked={selectedData.indexOf("MB229.51(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.5(2012)"
                        id="MB229.5(2012)"
                        onChange={handleChange("MB229.5(2012)")}
                        checked={selectedData.indexOf("MB229.5(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.31(2012)"
                        id="MB229.31(2012)"
                        onChange={handleChange("MB229.31(2012)")}
                        checked={selectedData.indexOf("MB229.31(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.3(2012)"
                        id="MB229.3(2012)"
                        onChange={handleChange("MB229.3(2012)")}
                        checked={selectedData.indexOf("MB229.3(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.1(2012)"
                        id="MB229.1(2012)"
                        onChange={handleChange("MB229.1(2012)")}
                        checked={selectedData.indexOf("MB229.1(2012)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.51(2009)"
                        id="MB229.51(2009)"
                        onChange={handleChange("MB229.51(2009)")}
                        checked={selectedData.indexOf("MB229.51(2009)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.5(2009)"
                        id="MB229.5(2009)"
                        onChange={handleChange("MB229.5(2009)")}
                        checked={selectedData.indexOf("MB229.5(2009)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.31(2009)"
                        id="MB229.31(2009)"
                        onChange={handleChange("MB229.31(2009)")}
                        checked={selectedData.indexOf("MB229.31(2009)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.3(2009)"
                        id="MB229.3(2009)"
                        onChange={handleChange("MB229.3(2009)")}
                        checked={selectedData.indexOf("MB229.3(2009)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="MB229.1(2009)"
                        id="MB229.1(2009)"
                        onChange={handleChange("MB229.1(2009)")}
                        checked={selectedData.indexOf("MB229.1(2009)") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "9" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("9")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="9"
                  >
                    فولکس‌واگن
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="9">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="VW51100(2018)"
                        id="VW51100(2018)"
                        onChange={handleChange("VW51100(2018)")}
                        checked={selectedData.indexOf("VW51100(2018)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50500 (2014)/50501(2018)"
                        id="VW50500 (2014)/50501(2018)"
                        onChange={handleChange("VW50500 (2014)/50501(2018)")}
                        checked={
                          selectedData.indexOf("VW50500 (2014)/50501(2018)") >
                          -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50888 (2013)/VW50999 (2013)"
                        id="VW50888 (2013)/VW50999 (2013)"
                        onChange={handleChange("VW50888 (2013)/VW50999 (2013)")}
                        checked={
                          selectedData.indexOf(
                            "VW50888 (2013)/VW50999 (2013)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50800 (2018)/VW50900 (2018)"
                        id="VW50800 (2018)/VW50900 (2018)"
                        onChange={handleChange("VW50800 (2018)/VW50900 (2018)")}
                        checked={
                          selectedData.indexOf(
                            "VW50800 (2018)/VW50900 (2018)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50601 (2000)/VW50301 (2000)"
                        id="VW50601 (2000)/VW50301 (2000)"
                        onChange={handleChange("VW50601 (2000)/VW50301 (2000)")}
                        checked={
                          selectedData.indexOf(
                            "VW50601 (2000)/VW50301 (2000)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50600 (1999)/VW50300 (1999)"
                        id="VW50600 (1999)/VW50300 (1999)"
                        onChange={handleChange("VW50600 (1999)/VW50300 (1999)")}
                        checked={
                          selectedData.indexOf(
                            "VW50600 (1999)/VW50300 (1999)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50200 (2005)/VW50500 (2010)"
                        id="VW50200 (2005)/VW50500 (2010)"
                        onChange={handleChange("VW50200 (2005)/VW50500 (2010)")}
                        checked={
                          selectedData.indexOf(
                            "VW50200 (2005)/VW50500 (2010)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50200 (1997)/VW50500 (1997)"
                        id="VW50200 (1997)/VW50500 (1997)"
                        onChange={handleChange("VW50200 (1997)/VW50500 (1997)")}
                        checked={
                          selectedData.indexOf(
                            "VW50200 (1997)/VW50500 (1997)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50400 (2012)/VW50700 (2004)"
                        id="VW50400 (2012)/VW50700 (2004)"
                        onChange={handleChange("VW50400 (2012)/VW50700 (2004)")}
                        checked={
                          selectedData.indexOf(
                            "VW50400 (2012)/VW50700 (2004)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50400 (2012)/VW50700 (2015)"
                        id="VW50400 (2012)/VW50700 (2015)"
                        onChange={handleChange("VW50400 (2012)/VW50700 (2015)")}
                        checked={
                          selectedData.indexOf(
                            "VW50400 (2012)/VW50700 (2015)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50400 (2020)/VW50700 (2020)"
                        id="VW50400 (2020)/VW50700 (2020)"
                        onChange={handleChange("VW50400 (2020)/VW50700 (2020)")}
                        checked={
                          selectedData.indexOf(
                            "VW50400 (2020)/VW50700 (2020)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50200 (2005)/VW50501 (2005)"
                        id="VW50200 (2005)/VW50501 (2005)"
                        onChange={handleChange("VW50200 (2005)/VW50501 (2005)")}
                        checked={
                          selectedData.indexOf(
                            "VW50200 (2005)/VW50501 (2005)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50200 (1997)/VW50501 (1999)"
                        id="VW50200 (1997)/VW50501 (1999)"
                        onChange={handleChange("VW50200 (1997)/VW50501 (1999)")}
                        checked={
                          selectedData.indexOf(
                            "VW50200 (1997)/VW50501 (1999)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50101 (2005)/VW50500 (2010)"
                        id="VW50101 (2005)/VW50500 (2010)"
                        onChange={handleChange("VW50101 (2005)/VW50500 (2010)")}
                        checked={
                          selectedData.indexOf(
                            "VW50101 (2005)/VW50500 (2010)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50101 (1997)/VW50500 (1997)"
                        id="VW50101 (1997)/VW50500 (1997)"
                        onChange={handleChange("VW50101 (1997)/VW50500 (1997)")}
                        checked={
                          selectedData.indexOf(
                            "VW50101 (1997)/VW50500 (1997)"
                          ) > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="VW50000 (1997)/VW50500 (1997)"
                        id="VW50000 (1997)/VW50500 (1997)"
                        onChange={handleChange("VW50000 (1997)/VW50500 (1997)")}
                        checked={
                          selectedData.indexOf(
                            "VW50000 (1997)/VW50500 (1997)"
                          ) > -1
                        }
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "10" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("10")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="10"
                  >
                    بی ام و
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="10">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="Longlife-17 FE+ (2018)"
                        id="Longlife-17 FE+ (2018)"
                        onChange={handleChange("Longlife-17 FE+ (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-17 FE+ (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-14 FE+ (2018)"
                        id="Longlife-14 FE+ (2018)"
                        onChange={handleChange("Longlife-14 FE+ (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-14 FE+ (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-12 FE (2018)"
                        id="Longlife-12 FE (2018)"
                        onChange={handleChange("Longlife-12 FE (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-12 FE (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-04 (2018)"
                        id="Longlife-04 (2018)"
                        onChange={handleChange("Longlife-04 (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-04 (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-01 (2018)"
                        id="Longlife-01 (2018)"
                        onChange={handleChange("Longlife-01 (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-01 (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-01 FE (2018)"
                        id="Longlife-01 FE (2018)"
                        onChange={handleChange("Longlife-01 FE (2018)")}
                        checked={
                          selectedData.indexOf("Longlife-01 FE (2018)") > -1
                        }
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-04"
                        id="Longlife-04"
                        onChange={handleChange("Longlife-04")}
                        checked={selectedData.indexOf("Longlife-04") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-01"
                        id="Longlife-01"
                        onChange={handleChange("Longlife-01")}
                        checked={selectedData.indexOf("Longlife-01") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-01 FE"
                        id="Longlife-01 FE"
                        onChange={handleChange("Longlife-01 FE")}
                        checked={selectedData.indexOf("Longlife-01 FE") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Longlife-98"
                        id="Longlife-98"
                        onChange={handleChange("Longlife-98")}
                        checked={selectedData.indexOf("Longlife-98") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "11" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("11")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="11"
                  >
                    جی ام - اوپل
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="11">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="dexos 1"
                        id="dexos 1"
                        onChange={handleChange("dexos 1")}
                        checked={selectedData.indexOf("dexos 1") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="dexos 2"
                        id="dexos 2"
                        onChange={handleChange("dexos 2")}
                        checked={selectedData.indexOf("dexos 2") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "12" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("12")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="12"
                  >
                    اوپل
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="12">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="B-040-2095"
                        id="B-040-2095"
                        onChange={handleChange("B-040-2095")}
                        checked={selectedData.indexOf("B-040-2095") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B-040-2098"
                        id="B-040-2098"
                        onChange={handleChange("B-040-2098")}
                        checked={selectedData.indexOf("B-040-2098") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "13" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("13")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="13"
                  >
                    رنو
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="13">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="RN17"
                        id="RN17"
                        onChange={handleChange("RN17")}
                        checked={selectedData.indexOf("RN17") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="RN0700"
                        id="RN0700"
                        onChange={handleChange("RN0700")}
                        checked={selectedData.indexOf("RN0700") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="RN0710"
                        id="RN0710"
                        onChange={handleChange("RN0710")}
                        checked={selectedData.indexOf("RN0710") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="RN0720"
                        id="RN0720"
                        onChange={handleChange("RN0720")}
                        checked={selectedData.indexOf("RN0720") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "14" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("14")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="14"
                  >
                    فورد
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="14">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="M2C948-B"
                        id="M2C948-B"
                        onChange={handleChange("M2C948-B")}
                        checked={selectedData.indexOf("M2C948-B") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="M2C913-D"
                        id="M2C913-D"
                        onChange={handleChange("M2C913-D")}
                        checked={selectedData.indexOf("M2C913-D") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="M2C913-C"
                        id="M2C913-C"
                        onChange={handleChange("M2C913-C")}
                        checked={selectedData.indexOf("M2C913-C") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="M2C913-B"
                        id="M2C913-B"
                        onChange={handleChange("M2C913-B")}
                        checked={selectedData.indexOf("M2C913-B") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="M2C913-A"
                        id="M2C913-A"
                        onChange={handleChange("M2C913-A")}
                        checked={selectedData.indexOf("M2C913-A") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "15" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("15")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="15"
                  >
                    پورشه
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="15">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="A40"
                        id="A40"
                        onChange={handleChange("A40")}
                        checked={selectedData.indexOf("A40") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C40"
                        id="C40"
                        onChange={handleChange("C40")}
                        checked={selectedData.indexOf("C40") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="A30"
                        id="A30"
                        onChange={handleChange("A30")}
                        checked={selectedData.indexOf("A30") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="C20"
                        id="C20"
                        onChange={handleChange("C20")}
                        checked={selectedData.indexOf("C20") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>

              <div
                className={
                  activeId === "16" ? "panel-wrap active-panel" : "panel-wrap"
                }
              >
                <div className="panel-header">
                  <Accordion.Toggle
                    onClick={() => toggleActive("16")}
                    className="panel-toggle"
                    variant="link"
                    eventKey="16"
                  >
                    پـژو
                  </Accordion.Toggle>
                </div>

                <Accordion.Collapse eventKey="16">
                  <div className="panel-body">
                    <Form>
                      <Form.Check
                        type="checkbox"
                        label="B71 2300(2019)"
                        id="B71 2300(2019)"
                        onChange={handleChange("B71 2300(2019)")}
                        checked={selectedData.indexOf("B71 2300(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2296(2019)"
                        id="B71 2296(2019)"
                        onChange={handleChange("B71 2296(2019)")}
                        checked={selectedData.indexOf("B71 2296(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2290(2019)"
                        id="B71 2290(2019)"
                        onChange={handleChange("B71 2290(2019)")}
                        checked={selectedData.indexOf("B71 2290(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2297(2019)"
                        id="B71 2297(2019)"
                        onChange={handleChange("B71 2297(2019)")}
                        checked={selectedData.indexOf("B71 2297(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2312(2019)"
                        id="B71 2312(2019)"
                        onChange={handleChange("B71 2312(2019)")}
                        checked={selectedData.indexOf("B71 2312(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2302(2019)"
                        id="B71 2302(2019)"
                        onChange={handleChange("B71 2302(2019)")}
                        checked={selectedData.indexOf("B71 2302(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2010(2019)"
                        id="B71 2010(2019)"
                        onChange={handleChange("B71 2010(2019)")}
                        checked={selectedData.indexOf("B71 2010(2019)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2296(2013)"
                        id="B71 2296(2013)"
                        onChange={handleChange("B71 2296(2013)")}
                        checked={selectedData.indexOf("B71 2296(2013)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2290(2013)"
                        id="B71 2290(2013)"
                        onChange={handleChange("B71 2290(2013)")}
                        checked={selectedData.indexOf("B71 2290(2013)") > -1}
                      />
                      <Form.Check
                        type="checkbox"
                        label="B71 2312(2013)"
                        id="B71 2312(2013)"
                        onChange={handleChange("B71 2312(2013)")}
                        checked={selectedData.indexOf("B71 2312(2013)") > -1}
                      />
                    </Form>
                  </div>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
